import { PosthogAnalyticsAdapter } from '@monkvision/posthog';
import { getEnvOrThrow } from '@monkvision/common';

export const posthogAnalyticsAdapter = new PosthogAnalyticsAdapter({
  token: 'phc_DAUcprXMBnH6tLYhWjKYZ8wwLwXbYVY6hkPjx0MvIbM',
  api_host: 'https://eu.i.posthog.com',
  environnement: getEnvOrThrow('REACT_APP_ENVIRONMENT'),
  projectName: 'tesla-dashboard-app',
  release: '1.0.0',
});
